import { useEffect, useRef, useState } from 'react';
export const CHAT_ACCESS_EVENT='dworks:chat-access-blocked';
export const CHAT_ACCESS_MESSAGES={
  CHAT_CONNECTION_INACTIVE:'거래처와의 활성 연결이 없어 이 대화방을 이용할 수 없습니다.',
  CHAT_COUNTERPART_INACTIVE:'상대 업체가 이용 정지 상태여서 이 대화방을 이용할 수 없습니다.',
  CHAT_THREAD_NOT_FOUND:'대화방을 찾을 수 없거나 접근 권한이 없습니다.',
  CHAT_ACCESS_LOOKUP_FAILED:'대화방 이용 권한을 확인하지 못했습니다. 잠시 후 다시 시도해주세요.',
};
export function notifyChatAccessError(path,error) {
  if(!['CHAT_CONNECTION_INACTIVE','CHAT_COUNTERPART_INACTIVE','CHAT_THREAD_NOT_FOUND'].includes(error?.code))return;
  const threadId=String(path).match(/(?:chats|threads)\/([0-9a-f-]{36})(?:\/|$|\?)/i)?.[1]
    || String(path).match(/chat-media\/(?:vendor|factory)\/([0-9a-f-]{36})\//i)?.[1];
  if(threadId)window.dispatchEvent(new CustomEvent(CHAT_ACCESS_EVENT,{detail:{threadId,message:CHAT_ACCESS_MESSAGES[error.code]}}));
}
export function useBlockedChatRooms(onBlock) {
  const [blocked,setBlocked]=useState({});
  const ref=useRef({}),handler=useRef(onBlock);handler.current=onBlock;
  useEffect(()=>{
    const listener=({detail})=>{
      ref.current={...ref.current,[detail.threadId]:detail.message};
      setBlocked(ref.current);handler.current?.(detail.threadId);
    };
    window.addEventListener(CHAT_ACCESS_EVENT,listener);
    return()=>window.removeEventListener(CHAT_ACCESS_EVENT,listener);
  },[]);
  return {blocked,isBlocked:id=>Boolean(ref.current[id])};
}
